import { getCookie } from 'feedback-public-submission-ui/utils/CookieUtils';
import { shouldSubmit } from './shouldSubmit';
export const getShouldShowThankYou = ({
  feedbackResponse,
  isThankYouPreview,
  params,
  surveyConfig
}) => feedbackResponse.followUpIsSubmitted || shouldSubmit(params) && getCookie(surveyConfig.contactId) || params.isPreview && isThankYouPreview;